<template>
<section class="main-info-section _edit-section">

    <div class="section-inner">

        <!--MainInfo-->
        <div class="main-info-item-wrap">

            <!--セールス募集-->
            <div class="main-info-item _recruiting">
                <h2 class="">セールス募集</h2>
                <SvgIconRecruiting />
                <div class="group form_checkbox">
                    <div class="md_label">
                        <span>BtoB</span>
                    </div>
                    <template v-for="(b_sales_recruitment, index) in bSalesRecruitmentList" v-bind:key="index">
                        <input type="checkbox" name="sales-check1" class="" :id="'sales-check1-' + index" v-on:change="changeBSalesRecruitment(b_sales_recruitment)" v-bind:checked="b_sales_recruitment.checked">
                        <label :for="'sales-check1-' + index">
                            <div class="check-mark"><span></span></div>
                            <span>{{ b_sales_recruitment.name }}</span>
                        </label>
                    </template>
                </div>
                <!-- <div class="group form_checkbox">
                    <div class="md_label">
                        <span>BtoC</span>
                    </div>
                    <template v-for="(c_sales_recruitment, index) in cSalesRecruitmentList" v-bind:key="index">
                        <input type="checkbox" name="sales-check2" class="" :id="'sales-check2-' + index" v-on:change="changeCSalesRecruitment(c_sales_recruitment)" v-bind:checked="c_sales_recruitment.checked">
                        <label :for="'sales-check2-' + index">
                            <div class="check-mark"><span></span></div>
                            <span>{{ c_sales_recruitment.name }}</span>
                        </label>
                    </template>
                </div> -->
            </div>

            <!--セールススタイル-->
            <div class="main-info-item _style">
                <h2 class="">セールススタイル</h2>
                <SvgIconSales />
                <div class="group form_checkbox">
                    <template v-for="(sales_style, index) in salesStyleList" v-bind:key="index">
                        <input type="checkbox" name="edit-sales-style" class="" :id="'edit-sales-style1' + index" v-on:change="changeSalesStyle(sales_style)" v-bind:checked="sales_style.checked">
                        <label :for="'edit-sales-style1' + index">
                            <div class="check-mark"><span></span></div>
                            <span>{{ sales_style.name }}</span>
                        </label>
                    </template>
                </div>
            </div>

            <!--卸値-->
            <div class="main-info-item _percents">
                <h2 class="">卸値</h2>
                <SvgIconPercent />
                <!-- Radio -->
                <div class="radio">
                    <div class="item form_radio">
                        <input type="radio" name="percent-select" class="" id="percent-select-text" :value="0" v-model="rate_dm_form" v-bind:checked="rate_dm_form == 0">
                        <label for="percent-select-text">
                            <span>AUMAトークで問い合わせてもらう</span>
                        </label>
                    </div>
                    <div class="item form_radio">
                        <input type="radio" name="percent-select" class="" id="percent-select-number" :value="1" v-model="rate_dm_form" v-bind:checked="rate_dm_form == 1">
                        <label for="percent-select-number">
                            <span>掛け率の数値を入力する</span>
                        </label>
                    </div>
                </div>
                <!-- Detail -->
                <div v-if="rate_dm_form == 1" class="detail _range">
                    <div>
                        <input type="number" class="edit-pen" v-model="rate_min"><span>%</span>
                    </div>
                    <div>
                        <input type="number" class="edit-pen" v-model="rate_max"><span>%</span>
                    </div>
                </div><!-- /Detail -->

                <!-- AddInput -->
                <div class="price-add-input">

                    <!-- 箱売り -->
                    <div class="row">
                        <div class="form_radio">
                            <input type="radio" name="percent-select" class="" id="price-add1" :value="2" v-model="rate_dm_form" v-bind:checked="rate_dm_form == 2">
                            <label for="price-add1">
                                <span>箱 (ケース) 売り</span>
                            </label>
                            <!-- Detail -->
                            <div class="detail " v-if="rate_dm_form == 2">
                                <div class="title">1個</div>
                            </div>
                            <div class="detail _range" v-if="rate_dm_form == 2">
                                <div>
                                    <input type="number" class="edit-pen" v-model="box_price_min"><span>円</span>
                                </div>
                                <div>
                                    <input type="number" class="edit-pen" v-model="box_price_max"><span>円</span>
                                </div>
                            </div><!-- /Detail -->
                        </div>
                    </div>

                    <!-- 量り売り -->
                    <div class="row">
                        <div class="form_radio">
                            <input type="radio" name="percent-select" class="" id="price-add2" :value="3" v-model="rate_dm_form" v-bind:checked="rate_dm_form == 3">
                            <label for="price-add2">
                                <span>量り売り</span>
                            </label>
                            <!-- Detail -->
                            <div class="detail _gramme" v-if="rate_dm_form == 3">
                                <div>1個</div>
                                <div>
                                    <input type="number" class="edit-pen" v-model="one_gram"><span>g</span>
                                </div>
                            </div>
                            <div class="detail _range" v-if="rate_dm_form == 3">
                                <div>
                                    <input type="number" class="edit-pen" v-model="gram_price_min"><span>円</span>
                                </div>
                                <div>
                                    <input type="number" class="edit-pen" v-model="gram_price_max"><span>円</span>
                                </div>
                            </div><!-- /Detail -->
                        </div>
                    </div>

                    <!-- 最小ロット数 -->
                    <div class="row">
                        <div class="form_radio">
                            <input type="radio" name="percent-select" class="" id="price-add4" :value="5" v-model="rate_dm_form" v-bind:checked="rate_dm_form == 5">
                            <label for="price-add4">
                                <span>最小ロット数</span>
                            </label>
                            <!-- Detail -->
                            <div class="detail" v-if="rate_dm_form == 5">
                                <div>
                                    <textarea class="edit-pen" maxlength="250" v-model="lot_free_text"></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <!-- 自由に記載する -->
                    <div class="row">
                        <div class="form_radio">
                            <input type="radio" name="percent-select" class="" id="price-add3" :value="4" v-model="rate_dm_form" v-bind:checked="rate_dm_form == 4">
                            <label for="price-add3">
                                <span>自由に記載する</span>
                            </label>
                            <!-- Detail -->
                            <div class="detail" v-if="rate_dm_form == 4">
                                <div>
                                    <textarea class="edit-pen" maxlength="250" v-model="price_free_text"></textarea>
                                </div>
                            </div>
                        </div>
                    </div>

                </div><!-- /AddInput -->

            </div><!--卸値-->

        </div><!--MainInfo-->

    </div>

</section><!--/.page-name-row-->
</template>

<style>
p {
    white-space: pre-wrap;
}
</style>

<script>
    //Svg
    import SvgIconPercent from '@/components/EndUser/svg/SvgIconPercent'
    import SvgIconSales from '@/components/EndUser/svg/SvgIconSales'
    import SvgIconRecruiting from '@/components/EndUser/svg/SvgIconRecruiting'
    export default {
        components: {
            SvgIconSales,
            SvgIconPercent,
            SvgIconRecruiting
        },
        data() {
            return {
                rate_dm_form: 0,
                rate_min: '',
                rate_max: '',
                box_price_min: '',
                box_price_max: '',
                one_gram: '',
                gram_price_min: '',
                gram_price_max: '',
                price_free_text: '',
                lot_free_text: '',

                b_sales_recruitments: [],
                // c_sales_recruitments: [],
                sales_styles: [],
                b_sales_recruitment_list: [],
                // c_sales_recruitment_list: [],
            }
        },
        mounted: function() {

            this.b_sales_recruitment_list = this.$store.state.register.set.sales_recruitment;
            // this.c_sales_recruitment_list = this.$store.state.register.set.sales_recruitment;

            // 編集の場合
            if (this.$store.state.detail.set.brand.b_sales_recruitments) {
                // DMでお問い合わせ
                this.rate_dm_form = Number(this.$store.state.detail.set.brand.rate_dm_form);
                this.$store.state.register.form.rate_dm_form = Number(this.$store.state.detail.set.brand.rate_dm_form);

                // 掛け率
                this.rate_min = this.$store.state.detail.set.brand.rate_min;
                this.$store.state.register.form.rate_min = this.$store.state.detail.set.brand.rate_min;

                this.rate_max = this.$store.state.detail.set.brand.rate_max;
                this.$store.state.register.form.rate_max = this.$store.state.detail.set.brand.rate_max;

                this.box_price_min = this.$store.state.detail.set.brand.box_price_min;
                this.$store.state.register.form.box_price_min = this.$store.state.detail.set.brand.box_price_min;

                this.box_price_max = this.$store.state.detail.set.brand.box_price_max;
                this.$store.state.register.form.box_price_max = this.$store.state.detail.set.brand.box_price_max;

                this.one_gram = this.$store.state.detail.set.brand.one_gram;
                this.$store.state.register.form.one_gram = this.$store.state.detail.set.brand.one_gram;

                this.gram_price_min = this.$store.state.detail.set.brand.gram_price_min;
                this.$store.state.register.form.gram_price_min = this.$store.state.detail.set.brand.gram_price_min;

                this.gram_price_max = this.$store.state.detail.set.brand.gram_price_max;
                this.$store.state.register.form.gram_price_max = this.$store.state.detail.set.brand.gram_price_max;
                
                this.lot_free_text = this.$store.state.detail.set.brand.lot_free_text;
                this.$store.state.register.form.lot_free_text = this.$store.state.detail.set.brand.lot_free_text;
                
                this.price_free_text = this.$store.state.detail.set.brand.price_free_text;
                this.$store.state.register.form.price_free_text = this.$store.state.detail.set.brand.price_free_text;

                // セールス募集(BtoB)
                this.b_sales_recruitments = this.$store.state.detail.set.brand.b_sales_recruitments;
                this.$store.state.register.form.b_sales_recruitment = this.$store.state.detail.set.brand.b_sales_recruitments;

                for(var i in this.b_sales_recruitment_list) {
                    var b_sales_recruitment = this.b_sales_recruitment_list[i];

                    // 選択されたデータがあればcheckedをもたせる
                    if (this.$store.state.detail.set.brand.b_sales_recruitments.some(detail_b_sales_recruitment => detail_b_sales_recruitment.id == b_sales_recruitment.id)) {
                        this.b_sales_recruitment_list[i].checked = true;
                    } 
                }

                // セールス募集(BtoC)
                // this.c_sales_recruitments = this.$store.state.detail.set.brand.c_sales_recruitments;
                // this.$store.state.register.form.c_sales_recruitment = this.$store.state.detail.set.brand.c_sales_recruitments;

                // for(var i in this.c_sales_recruitment_list) {
                //     var c_sales_recruitment = this.c_sales_recruitment_list[i];

                //     // 選択されたデータがあればcheckedをもたせる
                //     if (this.$store.state.detail.set.brand.c_sales_recruitments.some(detail_c_sales_recruitment => detail_c_sales_recruitment.id == c_sales_recruitment.id)) {
                //         this.c_sales_recruitment_list[i].checked = true;
                //     } 
                // }

                // セールススタイル
                this.sales_styles = this.$store.state.detail.set.brand.sales_styles;
                this.$store.state.register.form.sales_style = this.$store.state.detail.set.brand.sales_styles;

                for(var i in this.$store.state.register.set.sales_style) {
                    var sales_style = this.$store.state.register.set.sales_style[i];

                    // 選択されたデータがあればcheckedをもたせる
                    if (this.$store.state.detail.set.brand.sales_styles.some(detail_sales_style => detail_sales_style.id == sales_style.id)) {
                        this.$store.state.register.set.sales_style[i].checked = true;
                    } 
                }
            }
        },
        computed: {
            bSalesRecruitmentList(){
                return this.b_sales_recruitment_list;
            },
            // cSalesRecruitmentList(){
            //     return this.c_sales_recruitment_list;
            // },
            salesStyleList(){
                return this.$store.state.register.set.sales_style;
            },
            // プレビューのために並び替え
            sortedItemsBySalesRecruitmentsB(){
                return this.b_sales_recruitments.sort((a, b) => {
                    return (a.id < b.id) ? -1 : (a.id > b.id) ? 1 : 0;
                });;
            },
            // sortedItemsBySalesRecruitmentsC(){
            //     return this.c_sales_recruitments.sort((a, b) => {
            //         return (a.id < b.id) ? -1 : (a.id > b.id) ? 1 : 0;
            //     });;
            // },
            sortedItemsBySalesStyles(){
                return this.sales_styles.sort((a, b) => {
                    return (a.id < b.id) ? -1 : (a.id > b.id) ? 1 : 0;
                });;
            }
        },
        watch: {
            rate_dm_form: function (value) {
                this.$store.state.register.form.rate_dm_form = value;
            },
            rate_min: function (value) {
                this.$store.state.register.form.rate_min = value;
            },
            rate_max: function (value) {
                this.$store.state.register.form.rate_max = value;
            },
            box_price_min: function (value) {
                this.$store.state.register.form.box_price_min = value;
            },
            box_price_max: function (value) {
                this.$store.state.register.form.box_price_max = value;
            },
            one_gram: function (value) {
                this.$store.state.register.form.one_gram = value;
            },
            gram_price_min: function (value) {
                this.$store.state.register.form.gram_price_min = value;
            },
            gram_price_max: function (value) {
                this.$store.state.register.form.gram_price_max = value;
            },
            lot_free_text: function (value) {
                this.$store.state.register.form.lot_free_text = value;
            },
            price_free_text: function (value) {
                this.$store.state.register.form.price_free_text = value;
            },
        },
        methods: {
            changeBSalesRecruitment(value) {
                // 重複しているインデックス番号を取得
                var check_index = this.b_sales_recruitments.findIndex(b_sales_recruitment => b_sales_recruitment.id === value.id);
                if(check_index != -1) {
                    this.b_sales_recruitments.splice(check_index, 1);
                } else {
                    this.b_sales_recruitments.push(value);
                }
                this.$store.state.register.form.b_sales_recruitment = this.sortedItemsBySalesRecruitmentsB;
            },
            // changeCSalesRecruitment(value) {
            //     // 重複しているインデックス番号を取得
            //     var check_index = this.c_sales_recruitments.findIndex(c_sales_recruitment => c_sales_recruitment.id === value.id);
            //     if(check_index != -1) {
            //         this.c_sales_recruitments.splice(check_index, 1);
            //     } else {
            //         this.c_sales_recruitments.push(value);
            //     }
            //     this.$store.state.register.form.c_sales_recruitment = this.sortedItemsBySalesRecruitmentsC;
            // },
            changeSalesStyle(value) {
                // 重複しているインデックス番号を取得
                var check_index = this.sales_styles.findIndex(sales_style => sales_style.id === value.id);
                if(check_index != -1) {
                    this.sales_styles.splice(check_index, 1);
                } else {
                    this.sales_styles.push(value);
                }
                this.$store.state.register.form.sales_style = this.sortedItemsBySalesStyles;
            }
        }
    }
</script>
